import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { AtividadeComercial } from '../domain/atividade-comercial.model';

export class AtividadeComercialSerializer extends DomainSerializer<AtividadeComercial> {}
